import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    roofLength: string;
    roofWidth: string;
};

const Calculation = ({ setCalculationValue, roofLength, roofWidth }: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col>
                    <h3 className="d-sm-block">
                        {t("calculator.roofingCalculator.roofMeasurements")}
                    </h3>
                </Col>
            </Row>
            <Row>
                <CalculationField
                    name={"roofLength"}
                    dimension={"length"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={roofLength}
                    sm={4}
                    md={3}
                    lg={2}
                />
                <CalculationField
                    name={"roofWidth"}
                    dimension={"width"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    value={roofWidth}
                    sm={4}
                    md={3}
                    lg={2}
                />
            </Row>
        </div>
    );
};

export default Calculation;
